<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                    
                    <v-card elevation="1" class="mt-3" >
                        <div class="d-flex pt-3" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Registration Date</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu 
                                        ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        :return-value.sync="s_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="150px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field 
                                            v-model="s_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="d-flex align-self-center mt-0 pt-0"
                                            style="font-size:13px; "
                                            placeholder="Start Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="s_date" no-title scrollable :max="e_date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="s_date_search(s_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu
                                        ref="menu2"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :return-value.sync="e_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="220px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            v-model="e_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="align-self-center ma-0 pa-0"
                                            style="font-size:13px;width:190px;"
                                            placeholder="End Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="e_date" no-title scrollable :min="s_date" :max="date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="e_date_search(e_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex" >
                                    <v-btn-toggle v-model="toggleMonthBtn" class="pt-4">
                                        <v-btn small class="ml-1" @click="setSchDate(1)">Today</v-btn>
                                        <v-btn small  @click="setSchDate(2)">1 Week</v-btn>
                                        <!--<v-btn small  @click="setSchDate(3)">All</v-btn>-->
                                    </v-btn-toggle>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Classification</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <div class="d-flex pr-5" style="width:220px;">
                                    <v-autocomplete style="font-size:13px;" class="align-self-center" v-model="schBssSeq" :items="bssList" item-text="info" item-value="vals" label="Charger" @change="setBssInfo" outlined dense single-line hide-details>
                                    </v-autocomplete>
                                </div>
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schChargerID" :items="chargerList" item-text="info" item-value="vals" label="Charger ID" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                                
                                
                            </div>

                            
                        </div>
                        <!--
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Keyword</div>
                            <div class="d-flex" style="width:100%;">
                                <div class="d-flex pt-2 pr-auto" style="width:557px;">
                                    <v-text-field v-model="schText" outlined dense single-line hide-details small placeholder="Charger Station, Charger ID, Battery ID"></v-text-field>
                                </div>
                            </div>
                        </div>
                        -->
                        <div class="d-flex pb-5 justify-center" style="width:100%;">
                            <v-btn class="schClearBtn" small dark @click="searchFormReset()">Clear </v-btn>
                            <v-btn class="ml-2 schBtn" small dark @click="getList()">Search</v-btn>
                        </div>
                    </v-card>
                    <v-card elevation="1" class="mt-3">
                        <div class="d-flex flat pa-5" elevation="0" >
                            <div class="mr-auto align-self-center font-weight-bold text-subtitle-1" >Total <span class="listCnt">{{listTotalCnt}}</span></div>
                            <div class="pr-2">
                               
                            </div>
                        </div>
                        <div>
                            <table style="width:100%;" cellspacing="0" cellpadding="0" class="px-5">
                                <tr class="listHeader">
                                    <th style="width:20px"><v-checkbox class="align-self-center pl-2 ma-0" hide-details color="white" dark @click="checkedAll" v-model="allSelected"></v-checkbox></th>
                                    <th style="width:20px">No</th>
                                    <th style="width:12%">Registration Date</th>
                                    <th style="width:10%">National</th>
                                    <th style="width:12%">Charger Station </th>
                                    <th style="width:8%">Charger ID</th>
                                    <th style="width:8%">Battery ID1</th>
                                    <th style="width:5%">SOC1</th>
                                    <th style="width:8%">Battery ID2</th>
                                    <th style="width:5%">SOC2</th>                                    
                                    <th style="width:12%">Status</th>
                                    <th style="">LOG</th>
                                </tr>
                                <tr v-for="(item, index) in ebikeList" :key="item.SEQ">
                                    <td class="rowList"><v-checkbox v-model="selectEbkSeq" class="align-self-center pl-2 ma-0" hide-details  :value=item.SEQ @click="selected()"></v-checkbox></td>
                                    <td class="rowList">{{(listTotalCnt - (page -1) * 10) - index}}</td>
                                    <td class="rowList">{{item.INS_DTM}}</td>
                                    <td class="rowList">{{item.NAT_NAME_KR}}</td>
                                    <td class="rowList"><span style="color:#1976D2;cursor:pointer;" @click="viewInfo(item.SEQ)">{{item.BSS_NM}}</span></td>
                                    <td class="rowList">{{item.CHARGER_ID}}</td>
                                    <td class="rowList">{{item.BAT_ID1}}</td>
                                    <td class="rowList">{{item.BAT_SOC1}}</td>
                                    <td class="rowList">{{item.BAT_ID2}}</td>
                                    <td class="rowList">{{item.BAT_SOC2}}</td>
                                    <td class="rowList">{{item.CATEGORY}}</td>
                                    <td class="rowList">{{item.Error_DETAIL}}</td>
                                </tr>
                                <tr v-if="emptyFlag=='Y'">
                                    <td colspan="12" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </table>
                            <div class="pa2" v-if="listTotalCnt>0">
                                <div class="text-center mt-5">
                                    <!--
                                    <v-pagination v-model="page" :length="pagelength" 
                                    :total-visible=10
                                    @input="getPageList"></v-pagination>
                                    -->
                                    <Paging :currentPage="page" :totalPages="pagelength" :key="listTotalCnt" :totalCount="listTotalCnt" @onPageChange="onPageChange" @change="setBssInfo" />
                                </div>
                               
                            </div>
                            <div class="d-flex justify-space-between dense pa-5">
                                <div class="pa2 pl-2 " >
                                    <!-- <v-btn class="excelBtn" dark >Excel Download</v-btn> -->
                                </div>
                                <div class="pa2 pr-2">
                                    <!-- <v-btn color="green lighten-2" small dark class="ml-2">Excel Registration</v-btn> -->
                                    <!-- <v-btn color="primary" small dark class="ml-2" @click="registerVehicle">New Registration</v-btn> -->
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="dataloading" width="100"  >

                <div class="pt-5 text-center align-center justify-center" style="height:100px; background-color:#FFF" height="200">
                    <v-progress-circular
                    indeterminate
                    color="red" :size="50" 
                    ></v-progress-circular>
                </div>
            </v-dialog>
        </div>
    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    /*.theme--light.v-btn.v-btn--has-bg {background-color: #1e2c3c !important; color:#fff}*/
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'
import Paging from '@/components/paging.vue'

export default {
    name: 'BssLog',
    components: { Gnb, Footer, Navs, PageCrumbs, Paging },

    data () {
        return {
            // login Info
            gnbCode:"3", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:2, navCode2:21, 
            // Page Title & Breadcrumbs
            pTitles: "Charger Log",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Charger', disabled: true,}, { text: 'Charger Log', disabled: false,}, ],
            NavList: [ 
                        { title: 'Charger Management', nums: '1',
                            items: [ { title: 'Charger List', nums:11, href:'/Bss' , icons:'mdi-format-list-bulleted' },{ title: 'New Registration', nums:12, href:'/BssWrite', icons:'mdi-lead-pencil' },],
                        },
                        { title: 'Charger Log', nums: '2',
                            items: [ { title: 'Charger Log',nums:21, href:'/BssLog', icons:'mdi-format-list-bulleted' },],
                        },
                    ], 
           
            // List count & Pagination 
            listTotalCnt: 0, page: 0, pagelength:0, ebikeList:[],
            emptyFlag: 'Y',
            // Datepicker & Short button
            date: new Date().toISOString().substr(0, 10), 
            s_date: "", e_date: "", menu1: false, menu2: false,
            toggleMonthBtn:2,

            // Search form : select 
            countryList: [{info: 'Indonesia', vals: "ID"}, {info: 'korea', vals: "KR"}],
            
            schCountryCode: "", schText:"",  
            
            bssList:[], chargerList:[{info: 'ALL', vals: "ALL"},], schBssSeq:"", schChargerID: "", schChargerFlag : false,

            // Checkbox
            selectEbkSeq:[], allSelected: false,
            // Async & Modify Result
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false, dataloading: false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        this.page = 1;
        this.getBssList();
        localStorage.removeItem("schBssLogSeq");
        //localStorage.removeItem("schBssLogCID");
    },

    methods : {

        getBssList() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1, "authCode": this.loginInfo3 })
            };
            //console.log(requestOptions.body);
            fetch('https://api.e3bss.com/_APP/POC/cfg_bss.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                //console.log(json.value.list );
                if(json.result == "success") {
                    this.bssList = [];
                    this.bssList = json.value.list;
                } else {
                    this.bssList = [];
                }
                //console.log( this.bssList);
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
                //alert('충전소 정보를 확인할 수 없습니다');
            });
        }, 

        setBssInfo() {
            if(this.schBssSeq != '') { 
                
                this.schChargerInfo();
            }
        },

        schChargerInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1, "authCode": this.loginInfo3, "schBssSeq": this.schBssSeq })
            };
            //console.log(JSON.stringify({ "usrID": this.loginInfo1, "authCode": this.loginInfo3, "schBssSeq": this.schBssSeq }));
            fetch('https://api.e3bss.com/_APP/POC/cfg_charger.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                //console.log(json.value.list );
                if(json.result == "success") {
                    this.schChargerFlag  = true;
                    this.chargerList = [];
                    this.chargerList = json.value.list;
                } else {
                    this.schChargerFlag  = false;
                    this.chargerList = [];
                }
                //console.log( this.chargerList);
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
                //alert('충전소에 할당한 충전기정보를 확인할 수 없습니다');
            });
        },

        // datepicker 
        setSchDate(arg) {
            if(arg == 1) {
                this.s_date = new Date().toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 2) {
                let now = new Date();
                this.s_date =  new Date(now.setMonth(now.getMonth() - 1));
                this.s_date = this.s_date.toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 3) {
                this.s_date = '';
                this.e_date = '';
            }
        },

        // datepicker - sub
        s_date_search(v) {
            this.s_date = v;
            this.menu1 = false;
            this.$refs.menu1.save(v);
        },

        // datepicker - sub
        e_date_search(v) {
            this.e_date = v;
            this.menu2 = false;
            this.$refs.menu2.save(v);
        },

        // search form reset
        searchFormReset() {
            this.s_date=""; this.e_date="";
            this.schCountryCode=""; this.schUsrClsCode=""; this.schAprvStatus=""; this.schText="";
            this.page = 1;
            this.schBssSeq = ''; this.schChargerID  = '';

            //this.getList(this.page);
        },

        getPageList() {
            //console.log(this.page);
            this.getList(this.page);
        },

        // API Async 
        getList(page) {
            this.dataloading=true;
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L2"
                    , "page":page
                    , "schBssSeq": this.schBssSeq
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schChargerID": this.schChargerID 
                })
            };
            //console.log(requestOptions.body);
            
            fetch('https://api.e3bss.com/_APP/POC/bssLog.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                //console.log(json.value.list );
                if(json.result == "success") {
                    this.ebikeList =[];
                    this.ebikeList = json.value.list;
                    this.listTotalCnt = Number(json.totalCnt);
                    this.pagelength = json.totalPage;
                    this.page = json.currentPage;
                    this.emptyFlag = "N";
                    this.dataloading=false;
                } else {
                    this.ebikeList = [];
                    this.emptyFlag = "Y";
                    this.listTotalCnt = 0;
                    this.dataloading=false;
                }
                //console.log( this.ebikeList);
            }).catch((error) => {
                console.log(error);
                //this.$router.replace('Error');
            });
        },

        
        
        viewInfo(arg) {
            //console.log(arg, arg2);
            localStorage.setItem("schBssLogSeq", arg);
            //localStorage.setItem("schBssLogCID", arg2);
            this.$router.push({ name: 'BssLogDetail', params: { schBssLogSeq: arg}})
        },

        checkedAll() {
            //console.log('click');
            this.selectEbkSeq = [];

            if (this.allSelected) {
                for (let ebkies in this.ebikeList) {
                    this.selectEbkSeq.push(this.ebikeList[ebkies].RSV_SEQ.toString());
                }
            }
        },

        selected: function() {
            this.allSelected = false;
        }, 
        
        closeDialog(cls) {
            if(cls == "Success") {
                this.asyncSuccess = false;
            } else if(cls == "Error") {
                this.asyncErrors = false;
            }
            
            this.selectEbkSeq = [];
            this.allSelected=false;
        },
        
        onPageChange(param) {
            //console.log("onPageChange="+param);
            this.page = param;
            //console.log("this.page="+Number(this.page));
            this.getList(this.page);
        }


    }

}
</script>
